import { jsx } from 'react/jsx-runtime';
import Script from 'next/script';

const getAbTastyScriptSrc = jsId => new URL(`/${jsId}.js`, 'https://try.abtasty.com');

const AbTastyScript = ({ jsId, }) => (jsx(Script, { src: `${getAbTastyScriptSrc(jsId)}`, strategy: "afterInteractive" }));

export { AbTastyScript as A, getAbTastyScriptSrc as g };
//# sourceMappingURL=component-BjRqldY0.js.map
